import Logo from '@/components/feature/Logo';

interface MaintenancePageProps {
  title?: string | null;
  message?: string | null;
  endAt?: string | null;
}

const formatEndTime = (iso: string | null) => {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleString('vi-VN', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export default function MaintenancePage({ title, message, endAt }: MaintenancePageProps) {
  const endLabel = formatEndTime(endAt);

  return (
    <div className="min-h-screen bg-background-50 flex items-center justify-center px-4 md:px-6 relative overflow-hidden">
      <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-accent-500/10 blur-3xl"></div>
      <div className="absolute -bottom-24 -left-24 w-72 h-72 rounded-full bg-primary-500/10 blur-3xl"></div>

      <div className="relative w-full max-w-md text-center">
        <div className="flex justify-center mb-8">
          <Logo />
        </div>

        <div className="w-20 h-20 mx-auto rounded-2xl bg-accent-500/15 flex items-center justify-center mb-6">
          <i className="ri-tools-line text-accent-400 text-4xl w-10 h-10 flex items-center justify-center"></i>
        </div>

        <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
          {title || 'Website đang bảo trì'}
        </h1>

        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
          {message || 'Chúng tôi đang nâng cấp hệ thống để mang đến trải nghiệm tốt hơn. Vui lòng quay lại sau ít phút nữa.'}
        </p>

        {endLabel && (
          <div className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-100 border border-background-200/70">
            <i className="ri-time-line text-accent-400 text-lg"></i>
            <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">
              Dự kiến hoàn thành: {endLabel}
            </span>
          </div>
        )}

        <div className="mt-10 flex items-center justify-center gap-2 text-foreground-500">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse" style={{ animationDelay: '0.2s' }}></span>
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse" style={{ animationDelay: '0.4s' }}></span>
        </div>
      </div>
    </div>
  );
}